// extracted by mini-css-extract-plugin
module.exports = {"container":"AddStrategy_container__3BAgv"};